<template>
  <el-config-provider namespace="el" :locale="locale">
    <XDefaultLayout />
  </el-config-provider>
</template>

<script lang="ts" setup>
  import locale from 'element-plus/dist/locale/de'
</script>